const meditations = [
  [
    "Master the blade and you need fear no swordsman.",
    "Master the mind and you need fear noone.",
  ],
  "Consider the world an oyster and yourself the pearl.",
  "Music is to emotion as wealth is to power.",
  [
    "The novice speculator buys Bitcoin Core.",
    "The seasoned revolutionary buys Bitcoin Cash.",
  ],
  "Strike without fear but hide without hesitation.",
  "If value is in the mind of the beholder, the poor man can choose wealth and the rich man destitution.",
  "Everything is required to produce something from nothing.",
  "It is impossible to save a drowning man while he persists in blaming the ocean and refusing the proffered rope.",
  "Pond contamination eludes the diagnostics of the fish.",
  "Elevation permits the eagle to defeat the mouse but not the rifle.",
  ["Humility is the price of wisdom.", "Arrogance is the price of humility."],
  "Expertise = impact:adjustment",
  "The invincible general stations his archers on the ramparts of reality and cavalry obtuse to delusion.",
  "An information advantage brings victory, even in chess.",
  "An exponential appears initially trivial to linear thinking.",
  "A paradigm shift cannot be reasoned by analogy.",
  "Show, don't tell.",
  "Consciousness is teardrops in the river of time.",
  "Cause and effect are only related at an angle.",
  "A door is only closed to a locksmith.",
  ["Action is the refraction of thought.", "Thought is the shadow of desire."],
  "Inspiration keeps time with insistence.",
  "A miracle is only believable to the faithful.",
  ["The ninja evades the arrow.", "The sage evades the archer."],
  "Probable is the cousin of improbable and the daughter of impossible.",
  "Answers are the thief of education.",
  "Impact is not proportional to efficiency.",
  "The less said, the more understood.",
  "Freedom is forgetting.",
  "Apathy circumvents anger.",
  ["Freedom is power.", "Power is obligation.", "Obligation is slavery."],
  "An ocean is constrained by the shore.",
  ["Everyone makes mistakes.", "Not everyone repeats them."],
  "The future is perpetually at stake.",
  "Lack of fog does not imply clear vision.",
  "People are not wired for exponential invisible butterflies.",
  "System energy comes from aggregate node agitation.",
  "Circumstance is choice's canon.",
  ["Failing is hard.", "Succeeding is easy."],
  ["Speak into the void.", "Listen to silence."],
  ["To surpass a skill ceiling, do not learn.", "Unlearn."],
  "Cumulative resources snowball snowflake to avalanche.",
  "Foresight is accurate extrapolation.",
  "Only the rich and the poor wake up early.",
  "I do not need to know that it is simple, likely or easy - only that it is possible.",
  "Most people plan for the future based on the past, rather than the future.",
  "Outracing the herd requires patience, not speed.",
  "Mockery is both father and son to vindication.",
  "Resilient defiance is only demonstrable in the face of significant adversity.",
  [
    "Surpassed levels seem trivial.",
    "Pending levels seem titanic.",
    "Difficulty and capability are the same exponential.",
  ],
  [
    "An engineer knows excellent engineering is required.",
    "Everyone else knows it isn't sufficient.",
  ],
  [
    "If your life depended on it, you could get it done.",
    "Your life does depend on it.",
    "Time is holding the gun.",
  ],
  [
    "Nothing happens overnight.",
    "But nothing happens for most people over most nights.",
  ],
  "Pessimists only win pyrrhic victories.",
  [
    "Talk to the people who take you seriously.",
    "If there aren't any, broaden your search or rethink your ideas."
  ],
  "Criticism is proportional to quality."
];

export default meditations;
